export default __webpack_public_path__ + "static/media/VAULT Intelligence.d4a3247f.png";